import { DependencyContainer } from 'tsyringe'
import InjectionToken from 'tsyringe/dist/typings/providers/injection-token'

export const createValueRegistrationFunction = (c: DependencyContainer) => <T>(
  token: InjectionToken<T>,
  value: T
) => {
  c.register(token, { useValue: value })
}
